// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"ff7cc5f8","258":"d2b2c4e8","307":"3f65ce02","424":"c62c8b4a","815":"82080957","898":"b8cc621d","948":"2564606f"}[chunkId] + ".chunk.js";
};